import React, { ReactNode, Ref } from 'react';

type BaseProps = {
  children: ReactNode;
  className?: string;
  buttonRef?: Ref<HTMLButtonElement | HTMLAnchorElement>;
};

type ButtonAsButton = BaseProps &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, keyof BaseProps> & {
    as: 'button';
  };

type ButtonAsExternal = BaseProps &
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof BaseProps> & {
    as: 'externalLink';
  };

export type ButtonAsLink = Omit<ButtonAsExternal, 'as'> & {
  as: 'link';
};

export type ButtonProps = ButtonAsButton | ButtonAsExternal | ButtonAsLink;

const Button = (props: ButtonProps) => {
  const { buttonRef, ...restProps } = props;
  switch (props.as) {
    case 'link':
      return <a ref={buttonRef as Ref<HTMLAnchorElement>} {...(restProps as ButtonAsLink)} />;
    case 'externalLink':
      return (
        <a
          ref={buttonRef as Ref<HTMLAnchorElement>}
          target="_blank"
          rel="noreferrer"
          {...(restProps as ButtonAsExternal)}
        />
      );
    case 'button':
      return (
        <button ref={buttonRef as Ref<HTMLButtonElement>} {...(restProps as ButtonAsButton)} />
      );
    default:
      throw new Error('could not determine the correct button type');
  }
};

export default Button;
